import React from 'react';
import { IntlProvider } from 'react-intl'
import { useSelector } from 'react-redux';
import { isEmpty } from 'lodash';
import { Translations } from '../types/types';
import translations from '../locales/translations';
import { flatten } from '../helpers/objects';
import selectors from '../store/selectors';
import actions from '../store/actions';
import { useDispatch } from 'react-redux';
import { getStorageItem, hasStorageItem } from '../helpers/storage';

const IntlMessagesProvider = ({ children }: { children: React.ReactNode }) => {
    const dispatch = useDispatch();

    const LSTranslation = getStorageItem('language');
    const language = useSelector(selectors.settings.selectLanguage);
    const rigiLanguage = useSelector(selectors.settings.selectRigiLanguage);

    const displayLanguage = !isEmpty(rigiLanguage) ? rigiLanguage : language

    React.useEffect(() => {
        if (hasStorageItem('language') && LSTranslation) {
            dispatch(actions.settings.updateLanguage(LSTranslation));
        }
    }, [LSTranslation])

    const messages = translations as Translations
    const flattenedMessages = flatten(messages[displayLanguage])

    return (
        <IntlProvider locale={'EN'} messages={flattenedMessages}>
            {children}
        </IntlProvider>
    )
}

export default IntlMessagesProvider;